import PartnershipsLandingMain from '@components/partnerships';

const PartnershipsLandingPage = () => {
    return <PartnershipsLandingMain />;
};

export default PartnershipsLandingPage;
